import React from 'react'

export const ChatVideoIcon = ({
  size = 30,
  className,
  opacity = 1,
}: {
  color?: string
  size?: number
  className?: string
  opacity?: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      className={className}
      fill="none"
      opacity={opacity}
    >
      <g>
        <path
          d="M15 7.25C15.4142 7.25 15.75 7.58579 15.75 8C15.7497 8.414 15.4141 8.75 15 8.75H12C10.2051 8.75 8.75 10.2051 8.75 12V18C8.75025 19.7947 10.2052 21.25 12 21.25H18C19.7948 21.25 21.2497 19.7947 21.25 18V15C21.25 14.5858 21.5858 14.25 22 14.25C22.4142 14.25 22.75 14.5858 22.75 15V18C22.7497 20.6231 20.6232 22.75 18 22.75H12C9.3768 22.75 7.25025 20.6231 7.25 18V12C7.25 9.37665 9.37665 7.25 12 7.25H15ZM12.75 12.6719C12.7502 11.9408 13.5416 11.4841 14.1748 11.8496L18.0752 14.1016L18.1865 14.1758C18.6711 14.552 18.6712 15.2957 18.1865 15.6719L18.0752 15.7461L14.1748 17.998C13.5417 18.3633 12.7505 17.9065 12.75 17.1758V12.6719ZM14.25 16.2227L16.5 14.9238L14.25 13.625V16.2227ZM19.8535 7.31641C19.9112 7.19155 20.0888 7.19155 20.1465 7.31641L20.9229 8.99707C20.9389 9.0318 20.9672 9.06009 21.002 9.07617L22.6836 9.85352C22.8077 9.9114 22.8077 10.0876 22.6836 10.1455L21.002 10.9229C20.9672 10.9389 20.9389 10.9672 20.9229 11.002L20.1465 12.6826C20.0888 12.8075 19.9112 12.8075 19.8535 12.6826L19.0771 11.002C19.0611 10.9672 19.0328 10.9389 18.998 10.9229L17.3164 10.1455C17.1923 10.0876 17.1923 9.9114 17.3164 9.85352L18.998 9.07617C19.0328 9.06009 19.0611 9.0318 19.0771 8.99707L19.8535 7.31641Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default ChatVideoIcon
